<div class="top-section">
    <h6 class="heading mb-0">{{ ss.texts()['calendarAccount_title'] }}</h6>
    <div class="flex items-center gap-6">
        <app-svg name="importantMark" [color]="ss.theme().color14" width="20px" height="20px"
            *ngIf="cc.user.uid && ss.isInGracePeriod()" role="button" (click)="ds.featureExpiringSoon()"></app-svg>
        <app-svg name="more" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button" *ngIf="data.mode === 'edit'"
            [color]="ss.theme().color12"></app-svg>
        <mat-menu #infoMenu="matMenu" yPosition="above" xPosition="before" class="me-menu info-menu">
            <button mat-menu-item (click)="openFeatureGuide()">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="info" class="ri-pe-3"
                        [color]="ss.theme().color35"></app-svg>{{ ss.texts()['common_info'] }}</span>
            </button>
            <button mat-menu-item (click)="save(true)">
                <app-svg name="resync" [color]="ss.theme().color35" class="ri-me-3"></app-svg>
                <span class="text-14-400 color-8 text-center w-full">{{ ss.texts()['calendarAccount_resyncCalendar']
                    }}</span>
            </button>
            <button mat-menu-item (click)="deleteCalendar()">
                <app-svg name="trash" [color]="ss.theme().color11" class="ri-me-2"></app-svg>
                <span class="text-center text-14-400 color-11 w-full">{{ ss.texts()['deleteAccount_title']
                    }}</span>
            </button>
        </mat-menu>

        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
    </div>
</div>
<div class="calendar-account-form ri-p-4">
    <div>
        <!-- Account Info -->
        <div class="flex items-start ri-pb-4">
            <app-svg name="user" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ calendarAccountInfo.name }}</p>
                <p class="text-12-400 color-7 mb-0">{{ calendarAccountInfo.email }}</p>
            </div>
        </div>

        <!-- Mevolve to Calendar Section -->
        <div class="flex items-start ri-pb-4">
            <app-svg name="mevolveToCalendar" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ ss.texts()['calendarAccount_mevolveToCalendar'] }}</p>
                <p class="text-12-400 color-7 mb-0 ri-pb-2">{{ ss.texts()['calendarAccount_mevolveContent'] }}</p>

                <!-- Todos Sync -->
                <div class="flex justify-between items-center ri-pb-2">
                    <p class="text-16-400 color-8 mb-0 flex items-center">
                        {{ ss.texts()['common_todos'] }}
                        <app-svg *ngIf="isMevolveSyncEnabled('syncTodos')"
                            [name]="hasMevolveReminders('syncTodos') ? 'notification' : 'noNotification'"
                            [color]="hasMevolveReminders('syncTodos') ? ss.theme().color35 : ss.theme().color7"
                            class="ri-ms-2" (click)="toggleMevolveReminder('syncTodos')" role="button">
                        </app-svg>
                    </p>
                    <app-input-toggle [value]="isMevolveSyncEnabled('syncTodos')"
                        (toggle)="toggleMevolveSync('syncTodos')" [disabled]="isSaving() || isSyncing()"
                        [readonly]="true" [pointer]="true">
                    </app-input-toggle>
                </div>

                <!-- Habits Sync -->
                <div class="flex justify-between items-center ri-pb-2">
                    <p class="text-16-400 color-8 mb-0 flex items-center">
                        {{ ss.texts()['common_habits'] }}
                        <app-svg *ngIf="isMevolveSyncEnabled('syncHabits')"
                            [name]="hasMevolveReminders('syncHabits') ? 'notification' : 'noNotification'"
                            [color]="hasMevolveReminders('syncHabits') ? ss.theme().color35 : ss.theme().color7"
                            class="ri-ms-2" (click)="toggleMevolveReminder('syncHabits')" role="button">
                        </app-svg>
                    </p>
                    <app-input-toggle [value]="isMevolveSyncEnabled('syncHabits')"
                        (toggle)="toggleMevolveSync('syncHabits')" [disabled]="isSaving() || isSyncing()"
                        [readonly]="true" [pointer]="true">
                    </app-input-toggle>
                </div>

                <!-- Journals Sync -->
                <div class="flex justify-between items-center ri-pb-2">
                    <p class="text-16-400 color-8 mb-0 flex items-center">
                        {{ ss.texts()['common_journals'] }}
                        <app-svg *ngIf="isMevolveSyncEnabled('syncJournals')"
                            [name]="hasMevolveReminders('syncJournals') ? 'notification' : 'noNotification'"
                            [color]="hasMevolveReminders('syncJournals') ? ss.theme().color35 : ss.theme().color7"
                            class="ri-ms-2" (click)="toggleMevolveReminder('syncJournals')" role="button">
                        </app-svg>
                    </p>
                    <app-input-toggle [value]="isMevolveSyncEnabled('syncJournals')"
                        (toggle)="toggleMevolveSync('syncJournals')" [disabled]="isSaving() || isSyncing()"
                        [readonly]="true" [pointer]="true">
                    </app-input-toggle>
                </div>
            </div>
        </div>

        <!-- Calendar to Mevolve Section -->
        <div class="flex items-start ri-pb-4">
            <app-svg name="calendarToMevolve" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ ss.texts()['calendarAccount_calendarToMevolve'] }}</p>
                <p class="text-12-400 color-7 mb-0 ri-pb-2">{{ ss.texts()['calendarAccount_calendarContent'] }}</p>

                <!-- Calendar Groups -->
                <ng-container *ngFor="let calGroup of currentState().calendarGroups">
                    <div class="flex justify-between items-center ri-pb-2">
                        <p class="text-16-400 color-8 mb-0 flex items-center">
                            {{ getCalendarGroupDisplayName(calGroup.title) }}
                            <app-svg *ngIf="isCalendarGroupEnabled(calGroup.id)"
                                [name]="hasCalendarGroupReminders(calGroup.id) ? 'notification' : 'noNotification'"
                                [color]="hasCalendarGroupReminders(calGroup.id) ? ss.theme().color35 : ss.theme().color7"
                                class="ri-ms-2" (click)="toggleCalendarGroupReminder(calGroup.id)" role="button">
                            </app-svg>
                        </p>
                        <app-input-toggle [value]="isCalendarGroupEnabled(calGroup.id)"
                            (toggle)="toggleCalendarGroup(calGroup.id)" [disabled]="isSaving() || isSyncing()"
                            [readonly]="true" [pointer]="true">
                        </app-input-toggle>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="bottom-section ri-py-3 ri-px-4 ri-bt-2 flex items-center">

    <span class="flex items-center" *ngIf="isSaving() || isSyncing()">
        <app-svg name="resync" [color]="ss.theme().color35" class="ri-me-2" height="18px" width="18px"></app-svg>
        <span class="text-14-400 color-8">{{ ss.texts()['common_syncingEvents'] }}</span>
    </span>

    <button type="submit" class="btn-text text-16-500 color-35 ml-auto"
        (click)="(hasChanges() || data.mode === 'new') ? save() : closeDialog()" [disabled]="isSaving() || isSyncing()">
        {{ (hasChanges() || data.mode === 'new') ? ss.texts()['common_save'] : ss.texts()['common_close'] }}
    </button>
</div>